import { render, staticRenderFns } from "./taskUploadItem.vue?vue&type=template&id=2856ad98&scoped=true"
import script from "./taskUploadItem.vue?vue&type=script&lang=js"
export * from "./taskUploadItem.vue?vue&type=script&lang=js"
import style0 from "./taskUploadItem.vue?vue&type=style&index=0&id=2856ad98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2856ad98",
  null
  
)

export default component.exports